import React from "react";
import fileImage2 from "../../../../../assets/images/DeathModuleNew/fileuploaded.png";
import fileImage from "../../../../../assets/images/DeathModuleNew/startmessage.png";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../styles/disbilityDashboardStyle.css";
export const DisabilityDocumentDisplayCard = ({
  step,
  fileUpload,
  loading,
  moduleData,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <div className="DisabilityCardMain" style={{position:"relative"}}>
      <div className="cardHeadingDisability">
        {moduleData.name}
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/disability");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div className="cardDisabilityDesc">{moduleData.Purpose}</div>
      <div className="cardHeadingDisability">Uploaded Document </div>
      {fileUpload && fileUpload ? (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <img src={fileImage} height={80} width={85} alt="fileImage"></img>
          <div style={{ marginLeft: "1.5rem", marginTop: "1rem" }}>
            <div>
              {" "}
              <a
                style={{ color: "#7D8FB3" }}
                href={fileUpload && fileUpload["Document Upload"]}
                target="blank"
              >
                {fileUpload && fileUpload
                  ? fileUpload["Uploaded File Name"]
                  : ""}
              </a>{" "}
            </div>
            <div style={{ color: "#7d8fb3" }}>
              {" "}
              {fileUpload &&
                fileUpload &&
                moment(fileUpload.createdAt).format("MM-DD-YYYY")}
            </div>
          </div>
        </div>
      ) : (
        "No File Uploaded"
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};
